// Libraries
import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';

// Functions
import { getBaseUrl } from './baseURL';

/** Create an Axios Client with defaults **/
let client: AxiosInstance;

export const initializeClient = function () {
  client = axios.create({
    baseURL: getBaseUrl(),
    headers: {'Authorization': 'Bearer ' + localStorage.getItem('accessToken')}
  });
};

initializeClient();

/** Request Wrapper with default success/error actions **/
const request = function (options: AxiosRequestConfig<any>) {
  const onSuccess = function (response: any) {
    return response;
  };

  const onError = function (error: { config: any; response: { status: number; data: string; headers: any; }; message: any; }) {
    console.error('Request Failed: Config Sent:', error.config);

    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);

      if(error.response.status === 500){
        error.response.data = 'Error en el servidor';
      }
    } else {
      console.error('Error Message:', error.message);
    }
    return Promise.reject(error.response || error.message);
  };

  client.defaults.baseURL = getBaseUrl(options) + 'v1';
  return client(options).then(onSuccess).catch(onError);
};

export default request;